"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../../api/webAApi");
var UIUtils_1 = require("../../../../../../shared/modules/UIUtils");
var moment = require("moment");
var BrandPartnersListCtl = /** @class */ (function (_super) {
    __extends(BrandPartnersListCtl, _super);
    function BrandPartnersListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_brand_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_id; });
        _this.dk_brand_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_title; });
        _this.dk_pprogram_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.pprogram_id; });
        _this.dk_pprogram_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.pprogram_title; });
        _this.dk_usr_partner_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.usr_partner_id; });
        _this.dk_usr_partner_login = UIUtils_1.UIUtils.IProp2Str(function (o) { o.usr_partner_login; });
        _this.dk_app_currency_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_currency_id; });
        _this.dk_app_currency_iso = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_currency_iso; });
        _this.dk_offer_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.offer_id; });
        _this.dk_offer_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.offer_title; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this._errDialog = errDialog;
        return _this;
    }
    BrandPartnersListCtl.prototype.ResetData = function () {
        this.DATA = {
            total: 0,
            data: []
        };
    };
    BrandPartnersListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        return null;
    };
    BrandPartnersListCtl.prototype.LoadData = function (brandId, onDone) {
        var _this = this;
        webAApi_1.ListBrandPartnersForStatGet.exec({
            brand_id: brandId
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    brand_id: resp.list[i].brand_id,
                    brand_title: resp.list[i].brand_title,
                    pprogram_id: resp.list[i].pprogram_id,
                    pprogram_title: resp.list[i].pprogram_title,
                    usr_partner_id: resp.list[i].usr_partner_id,
                    usr_partner_login: resp.list[i].usr_partner_login,
                    app_currency_id: resp.list[i].app_currency_id,
                    app_currency_iso: resp.list[i].app_currency_iso,
                    offer_id: resp.list[i].offer_id,
                    offer_title: resp.list[i].offer_title,
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false)
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BrandPartnersListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddBrandPartnerForStat.exec({
            data: {
                brand_id: data.brand_id,
                app_currency_id: data.app_currency_id,
                pprogram_id: data.pprogram_id,
                usr_partner_id: data.usr_partner_id,
                usr_partner_offer_id: data.usr_partner_offer_id
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                brand_id: data.brand_id,
                brand_title: resp.brand_title,
                pprogram_id: data.pprogram_id,
                pprogram_title: resp.pprogram_title,
                usr_partner_id: data.usr_partner_id,
                usr_partner_login: resp.partner_login,
                app_currency_id: data.app_currency_id,
                app_currency_iso: resp.app_currency_iso,
                offer_id: data.usr_partner_offer_id,
                offer_title: resp.offer_title,
                date_added2: moment(resp.date_added_uts_ms).utc(false),
                date_changed2: moment(resp.date_added_uts_ms).utc(false)
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BrandPartnersListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditBrandPartnerForStat.exec({
                data: {
                    brands_partners_for_brand_stat_id: data.key,
                    brand_id: data.brand_id,
                    app_currency_id: data.app_currency_id,
                    pprogram_id: data.pprogram_id,
                    usr_partner_id: data.usr_partner_id,
                    usr_partner_offer_id: data.usr_partner_offer_id
                }
            }, function (resp) {
                _tmp.brand_id = data.brand_id;
                _tmp.brand_title = resp.brand_title;
                _tmp.app_currency_id = data.app_currency_id;
                _tmp.app_currency_iso = resp.app_currency_iso;
                _tmp.pprogram_id = data.pprogram_id;
                _tmp.pprogram_title = resp.pprogram_title;
                _tmp.offer_id = data.usr_partner_offer_id;
                _tmp.offer_title = resp.offer_title;
                _tmp.usr_partner_id = data.usr_partner_id;
                _tmp.usr_partner_login = resp.partner_login;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BrandPartnersListCtl.prototype.RemoveItem = function (accessKey) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === accessKey) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    BrandPartnersListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteBrandPartnerForStat.exec({
                data: {
                    usr_partner_for_brand_stat_id: key,
                }
            }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return BrandPartnersListCtl;
}(BaseController_1.BaseController));
exports.BrandPartnersListCtl = BrandPartnersListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_brands_list/ctl/options/BrandsPartnersListCtl.ts
// module id = 920
// module chunks = 0